/**
 * Minimal dataLayer push for add-to-cart (e.g. Made With Intent GTM tag).
 * Second argument: optional string (treated as { atc_source }) or object of extra keys.
 *
 * One dataLayer push per line item (same user action may produce multiple add_to_cart events).
 * Each push: { event: 'add_to_cart', currency, value, items: [singleItem], ...options }
 *
 * Shopify Ajax line prices are normally in minor units (cents). If you build synthetic lines
 * with prices already in major units, set line._datalayer_prices_in_major = true.
 */ 
(function () {
  
  function toNumber(n) {
    if (n == null || n === '') return NaN;
    var x = typeof n === 'string' ? parseFloat(n) : Number(n);
    return Number.isFinite(x) ? x : NaN;
  }

  function centsToMajor(cents) {
    var n = toNumber(cents);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n) / 100;
  }

  /** Shopify = minor (cents). Fractional amount under 10000 without flag = treat as already major (fixes mistaken 49.99 passed as minor). */
  function amountToMajor(raw, line) {
    var n = toNumber(raw);
    if (!Number.isFinite(n) || n <= 0) return 0;
    if (line && line._datalayer_prices_in_major === true) {
      return Math.round(n * 100) / 100;
    }
    var hasFraction = Math.abs(n - Math.round(n)) > 1e-6;
    if (hasFraction && n < 10000) {
      return Math.round(n * 100) / 100;
    }
    return centsToMajor(n);
  }

  function cartCurrencyCode(cart, optionsCurrency) {
    if (optionsCurrency) return String(optionsCurrency);
    try {
      if (cart && cart.currency) {
        if (typeof cart.currency === 'string') return cart.currency;
        if (cart.currency.iso_code) return String(cart.currency.iso_code);
      }
    } catch (e) {}
    try {
      var c = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartCurrency;
      if (c) return String(c);
    } catch (e2) {}
    return 'GBP';
  }

  function normalizeLines(data) {
    if (!data || typeof data !== 'object') return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.variant_id != null) return [data];
    return [];
  }

  function isLikelyError(data) {
    if (!data || typeof data !== 'object') return true;
    if (data.status === 422 || data.status === 404 || data.status === 400) return true;
    if (typeof data.description === 'string' && data.description && !data.variant_id && !data.items) return true;
    return false;
  }

  function lineMinorTotalRaw(line) {
    var qty = toNumber(line.quantity) || 0;
    var finalLine = toNumber(line.final_line_price);
    if (Number.isFinite(finalLine)) return finalLine;
    var linePrice = toNumber(line.line_price);
    if (Number.isFinite(linePrice)) return linePrice;
    var unit = toNumber(line.discounted_price);
    if (!Number.isFinite(unit)) unit = toNumber(line.price);
    if (Number.isFinite(unit) && qty > 0) return unit * qty;
    return 0;
  }

  function lineTotalMajor(line) {
    return amountToMajor(lineMinorTotalRaw(line), line);
  }

  function lineUnitPriceMajor(line) {
    var qty = toNumber(line.quantity) || 1;
    var rawTotal = lineMinorTotalRaw(line);
    if (rawTotal > 0 && qty > 0) {
      return amountToMajor(rawTotal / qty, line);
    }
    var unitMinor = toNumber(line.discounted_price);
    if (!Number.isFinite(unitMinor)) unitMinor = toNumber(line.price);
    if (Number.isFinite(unitMinor)) return amountToMajor(unitMinor, line);
    return 0;
  }

  /** Plain object for dataLayer / JSON.stringify (empty cart line.properties → {}). */
  function cloneLineProperties(line) {
    var props = line && line.properties;
    if (!props || typeof props !== 'object') return null;
    var out = {};
    try {
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k) && props[k] != null && props[k] !== '') {
          out[k] = props[k];
        }
      }
    } catch (e) {
      return null;
    }
    return Object.keys(out).length ? out : null;
  }

  function lineToItem(line) {
    var qty = Math.max(1, Math.floor(toNumber(line.quantity) || 1));
    var vid = line.variant_id != null ? String(line.variant_id) : '';
    var name = String(line.product_title || line.title || '').slice(0, 500);
    var sku = line.sku != null && line.sku !== '' ? String(line.sku) : '';
    var variant = line.variant_title ? String(line.variant_title) : '';
    var vendor = line.vendor ? String(line.vendor) : '';
    if (line.on_sale != null) {
      var on_sale = toNumber(line.on_sale);
    } else {
      var on_sale = toNumber(line.total_discount) > 0 ? 1 : 0;
    }

    if (sku.includes('-PACK') ||  sku.includes('-12WP') || sku.includes('-SHOT')) {
      var category = 'Single';
    } else if (sku.includes('-S01M') || sku.includes('-S06M') || sku.includes('-S12M')) {
      var category = 'Subscription';
    } else if (name.includes('Gift bundle')) {
      var category = 'Gift';
    } else {
      var category = 'Unknown';
    }
    
    var item = {
      id: vid,
      name: name,
      sku: sku,
      item_price: lineUnitPriceMajor(line),
      quantity: qty,
      category: category,
      total_price: lineTotalMajor(line),
      vendor: vendor,
      on_sale: on_sale,
    };

    if (variant) item.variant = variant;
    if (line.product_id != null) item.product_id = String(line.product_id);
    var props = cloneLineProperties(line);
    if (props) item.line_item_properties = props;
    return item;
  }

  function parseOptions(second) {
    if (second == null) return {};
    if (typeof second === 'string') return { atc_source: second };
    if (typeof second === 'object') return second;
    return {};
  }

  window.normalizeCartAddResponse = normalizeLines;

  /**
   * When journey.liquid and journey-page-js.liquid both load, they each attach ATC listeners;
   * the same click can call pushAddToCartDataLayer twice. Skip a second push with the same
   * variant:qty fingerprint within this window (ms). Override with secondArg.skip_dedupe === true.
   */
  var DEDUPE_WINDOW_MS =
    typeof window.__datalayerAtcDedupeMs === 'number' && window.__datalayerAtcDedupeMs >= 0
      ? window.__datalayerAtcDedupeMs
      : 1000;
  var lastAtcDedupeKey = '';
  var lastAtcDedupeTime = 0;

  function dedupeKeyForLines(lines) {
    if (!lines || !lines.length) return '';
    var parts = [];
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      var vid = l.variant_id != null ? l.variant_id : l.id;
      var q = Math.max(1, Math.floor(toNumber(l.quantity) || 1));
      parts.push(String(vid) + ':' + String(q));
    }
    parts.sort();
    return parts.join('|');
  }

  function logDebugSnapshot(label, obj) {
    if (obj === undefined) {
      console.log(label, undefined);
      return;
    }
    try {
      console.log(label, JSON.parse(JSON.stringify(obj)));
    } catch (e) {
      console.log(label + ' (fallback)', obj);
    }
  }

  window.pushAddToCartDataLayer = function (payload, secondArg) {
    logDebugSnapshot('payload debug', payload);
    logDebugSnapshot('secondArg', secondArg);
    if (isLikelyError(payload)) return;

    var lines = normalizeLines(payload);
    if (!lines.length) return;

    var options = parseOptions(secondArg);
    if (options.skip_dedupe !== true) {
      var dedupeKey = dedupeKeyForLines(lines);
      var now = Date.now();
      if (dedupeKey && dedupeKey === lastAtcDedupeKey && now - lastAtcDedupeTime < DEDUPE_WINDOW_MS) {
        return;
      }
      lastAtcDedupeKey = dedupeKey;
      lastAtcDedupeTime = now;
    }
    var currency = cartCurrencyCode(payload, options.currency);

    var baseExtra = {};
    for (var k in options) {
      if (
        Object.prototype.hasOwnProperty.call(options, k) &&
        k !== 'currency' &&
        k !== 'skip_dedupe'
      ) {
        baseExtra[k] = options[k];
      }
    }

    window.dataLayer = window.dataLayer || [];

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var item = lineToItem(line);
      var lineValue = lineTotalMajor(line);

      var dlEvent = {
        event: 'add_to_cart',
        currency: currency,
        value: lineValue,
        items: [item],
        // Flat fields so GTM/MWI can read this event without merged items[] collision.
        product_name: item.name,
        product_sku: item.sku,
        product_price: item.item_price,
        product_category: item.category,
        product_brand: item.vendor,
        product_variant: item.variant || '',
        product_quantity: item.quantity,
      };

      if (line._atc_line_role) {
        dlEvent.atc_line_role = line._atc_line_role;
      }

      for (var k in baseExtra) {
        if (Object.prototype.hasOwnProperty.call(baseExtra, k)) {
          dlEvent[k] = baseExtra[k];
        }
      }

      window.dataLayer.push(dlEvent);
    }
  };
})();
